import * as React from "react"

import Layout from "../components/Layout"

const ProjectFloorPlans = () => {
  return (
    <Layout>
      <h1>Lentor Modern Floor Plan</h1>

      <iframe
        title="Project_Floor_Plan"
        width="100%"
        height="600px"
        src="/LM_Showflat_layouts_10Aug22_v3_2.pdf#toolbar=0"
      ></iframe>
    </Layout>
  )
}

export default ProjectFloorPlans
